<template>
  <v-app class="momen-app">
    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-image-multiple-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Momen Terbaik</div>
            <div class="header-info-subtitle">Galeri dokumentasi kegiatan</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="main-container">
        <div class="content-wrapper">
          <div class="page-intro share-hero">
            <div class="share-hero-text">
              <div class="intro-label">
                <span class="intro-line"></span>
                GALERI MOMEN WARGA
              </div>

              <h1 class="intro-title">
                Bagikan Momen
                <span>Terbaikmu</span>
                di Sini
              </h1>

              <p class="intro-description">
                Punya foto kegiatan, wisata, atau momen istimewa di Bondowoso? Kirimkan
                dan tampil di galeri setelah diverifikasi admin.
              </p>

              <div class="share-cta-row">
                <v-btn
                  depressed
                  large
                  class="btn-bagikan white--text text-capitalize font-weight-bold rounded-lg"
                  @click="bukaForm"
                >
                  <v-icon left class="bagikan-icon">mdi-camera-plus-outline</v-icon>
                  Bagikan Momen
                </v-btn>

                <!-- <span class="share-note">
                  <v-icon x-small color="#018c74">mdi-shield-check-outline</v-icon>
                  Diverifikasi admin sebelum tayang
                </span> -->
              </div>
            </div>

            <div class="momen-counter">
              <div class="counter-icon">
                <v-icon>mdi-camera-iris</v-icon>
              </div>

              <div>
                <div class="counter-value">
                  {{ listMomen.length }}
                </div>

                <div class="counter-label">MOMEN 6 BULAN TERAKHIR</div>
              </div>
            </div>
          </div>

          <div v-if="listMomen.length" class="share-list-head">
            <v-icon small color="#018c74">mdi-clock-outline</v-icon>
            Momen terbaru &middot;
          </div>

          <div v-for="momen in listMomen" :key="momen.id" class="momen-section">
            <div class="momen-header">
              <div class="momen-header-line"></div>

              <div class="momen-header-text">
                <div class="momen-header-label">
                  TANGGAL: {{ formatDate(momen.tanggal_ambil) }}
                </div>

                <h3 class="momen-header-title">
                  {{ momen.judul_momen.toUpperCase() }}
                </h3>
              </div>

              <div class="momen-header-id d-none d-sm-block">
                #{{ momen.id.toString().padStart(3, "0") }}
              </div>
            </div>

            <div class="momen-grid">
              <div class="momen-main-wrapper">
                <div
                  class="momen-card momen-main"
                  @click="openDetail(splitPhotos(momen.list_foto)[0], momen)"
                >
                  <v-img
                    :src="
                      'https://berkah.bondowosokab.go.id:5500/uploads/' +
                      splitPhotos(momen.list_foto)[0]
                    "
                    height="360"
                    cover
                    class="momen-img"
                  >
                    <div class="momen-overlay d-flex flex-column justify-end pa-5">
                      <div class="momen-overlay-title">GAMBAR VISUAL</div>
                      <div class="momen-overlay-sub">KLIK UNTUK DETAIL</div>
                    </div>
                  </v-img>
                </div>
              </div>

              <div class="momen-sub-wrapper">
                <div
                  v-for="(img, idx) in splitPhotos(momen.list_foto).slice(1)"
                  :key="idx"
                  class="momen-card momen-sub"
                  @click="openDetail(img, momen)"
                >
                  <v-img
                    :src="'https://berkah.bondowosokab.go.id:5500/uploads/' + img"
                    height="170"
                    cover
                    class="momen-img"
                  >
                    <div class="momen-sub-overlay">
                      <v-icon color="white" small>mdi-plus</v-icon>
                    </div>
                  </v-img>
                </div>

                <div
                  v-if="splitPhotos(momen.list_foto).length < 2"
                  class="momen-placeholder"
                >
                  <v-icon color="#8b969f" small class="mr-2"
                    >mdi-image-off-outline</v-icon
                  >
                  <span>Tidak ada foto tambahan</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="listMomen.length === 0" class="empty-detail">
            <div class="empty-detail-icon">
              <v-icon size="54"> mdi-image-multiple-outline </v-icon>
            </div>

            <div class="empty-detail-title">Belum Ada Momen</div>

            <div class="empty-detail-description">
              Belum ada momen dalam 6 bulan terakhir. Jadilah yang pertama berbagi!
            </div>

            <v-btn
              depressed
              class="btn-bagikan white--text text-capitalize font-weight-bold rounded-lg mt-5"
              @click="bukaForm"
            >
              <v-icon left class="bagikan-icon">mdi-camera-plus-outline</v-icon>
              Bagikan Momen
            </v-btn>
          </div>

          <div class="page-footer">
            <div>BONDOWOSO BERKAH</div>

            <span></span>

            <div>GALERI DOKUMENTASI KEGIATAN</div>
          </div>
        </div>
      </v-container>
    </v-main>

    <v-dialog
      v-model="dialog"
      max-width="1100"
      overlay-color="#0d1f1c"
      overlay-opacity="0.65"
      transition="dialog-bottom-transition"
    >
      <v-card class="detail-dialog-panel overflow-hidden">
        <v-row no-gutters>
          <v-col cols="12" md="8" class="dialog-image-col">
            <v-img :src="selectedImg" contain max-height="85vh"></v-img>
          </v-col>

          <v-col cols="12" md="4" class="dialog-info-col pa-7 d-flex flex-column">
            <div class="detail-badge mb-3">
              <v-icon x-small> mdi-image-outline </v-icon>

              DETAIL MOMEN
            </div>

            <h2 class="dialog-title mb-4">
              {{ activeMomen.judul_momen }}
            </h2>

            <div class="dialog-meta-box mb-5">
              <div class="dialog-meta-row">
                <div class="date-icon">
                  <v-icon size="16"> mdi-clock-outline </v-icon>
                </div>

                <span class="dialog-meta-date">
                  {{ formatDate(activeMomen.tanggal_ambil) }}
                </span>
              </div>

              <p class="dialog-meta-desc">
                {{ activeMomen.deskripsi }}
              </p>
            </div>

            <v-spacer></v-spacer>

            <v-btn block class="dialog-close-btn" @click="dialog = false"> TUTUP </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- Tombol melayang: muncul (dengan animasi) setelah hero di-scroll -->
    <transition name="share-fab">
      <v-btn
        v-if="showFab && !formDialog"
        fab
        depressed
        class="share-fab white--text"
        aria-label="Bagikan momen"
        @click="bukaForm"
      >
        <v-icon>mdi-camera-plus-outline</v-icon>
      </v-btn>
    </transition>

    <!-- Form kirim momen -->
    <v-dialog
      v-model="formDialog"
      max-width="640"
      scrollable
      persistent
      overlay-color="#0d1f1c"
      overlay-opacity="0.65"
      transition="dialog-bottom-transition"
      @keydown.esc="tutupForm"
    >
      <v-card class="share-card">
        <!-- SUKSES -->
        <div v-if="selesai" class="share-success">
          <svg class="share-check" viewBox="0 0 52 52" aria-hidden="true">
            <circle class="share-check-circle" cx="26" cy="26" r="24" fill="none" />
            <path class="share-check-mark" fill="none" d="M14 27 l8 8 l16 -17" />
          </svg>
          <h3 class="share-success-title">Terima kasih!</h3>
          <p class="share-success-text">
            Momen Anda sudah kami terima dan sedang menunggu verifikasi admin. Jika
            disetujui, momen akan tampil di galeri ini.
          </p>
          <v-btn
            depressed
            class="btn-bagikan white--text text-capitalize font-weight-bold rounded-lg"
            @click="tutupForm"
          >
            Selesai
          </v-btn>
        </div>

        <!-- FORM -->
        <template v-else>
          <div class="share-card-head">
            <div class="share-card-icon">
              <v-icon color="white">mdi-camera-plus-outline</v-icon>
            </div>
            <div>
              <div class="share-card-title">Bagikan Momen Terbaikmu</div>
              <div class="share-card-sub">Akan diperiksa admin sebelum ditayangkan</div>
            </div>
            <v-spacer />
            <v-btn icon :disabled="kirim" aria-label="Tutup" @click="tutupForm">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <v-card-text class="share-card-body">
            <!-- Upload foto -->
            <div
              class="share-drop"
              :class="{ 'share-drop--active': dragging, 'share-drop--error': errFoto }"
              @click="$refs.inputFoto.click()"
              @dragover.prevent="dragging = true"
              @dragleave.prevent="dragging = false"
              @drop.prevent="onDrop"
            >
              <v-icon size="34" color="#018c74" class="share-drop-icon"
                >mdi-cloud-upload-outline</v-icon
              >
              <div class="share-drop-title">Klik atau seret foto ke sini</div>
              <div class="share-drop-sub">
                Maksimal {{ MAKS_FOTO }} foto &middot; JPG, PNG, WEBP &middot;
                {{ MAKS_UKURAN_MB }} MB per foto
              </div>
              <input
                ref="inputFoto"
                type="file"
                accept="image/jpeg,image/png,image/webp"
                multiple
                class="d-none"
                @change="pilihFoto"
              />
            </div>
            <div v-if="errFoto" class="share-error">{{ errFoto }}</div>

            <transition-group name="share-thumb" tag="div" class="share-thumbs">
              <div v-for="(f, i) in fotoList" :key="f.url" class="share-thumb">
                <img :src="f.url" alt="" />
                <span v-if="i === 0" class="share-thumb-badge">UTAMA</span>
                <button
                  type="button"
                  class="share-thumb-del"
                  aria-label="Hapus foto"
                  :disabled="kirim"
                  @click.stop="hapusFoto(i)"
                >
                  <v-icon x-small color="white">mdi-close</v-icon>
                </button>
              </div>
            </transition-group>

            <v-text-field
              v-model="form.judul"
              label="Judul momen *"
              outlined
              dense
              maxlength="255"
              counter
              class="mt-4"
              :disabled="kirim"
              :error-messages="errJudul"
              @input="errJudul = ''"
            />

            <v-textarea
              v-model="form.deskripsi"
              label="Ceritakan momen ini (opsional)"
              outlined
              dense
              rows="3"
              auto-grow
              maxlength="2000"
              counter
              :disabled="kirim"
            />

            <v-text-field
              v-model="form.tanggal"
              type="date"
              label="Tanggal momen *"
              outlined
              dense
              :min="batasBawah"
              :max="hariIni"
              hint="Maksimal hari ini, paling lama 6 bulan terakhir"
              persistent-hint
              :disabled="kirim"
              :error-messages="errTanggal"
              @input="errTanggal = ''"
            />

            <v-row dense class="mt-3">
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.nama"
                  label="Nama Anda (opsional)"
                  outlined
                  dense
                  maxlength="100"
                  :disabled="kirim"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.kontak"
                  label="No. HP (opsional)"
                  outlined
                  dense
                  maxlength="20"
                  inputmode="tel"
                  hint="Tidak ditampilkan, hanya untuk konfirmasi admin"
                  persistent-hint
                  :disabled="kirim"
                  @blur="rapikanKontak"
                />
              </v-col>
            </v-row>

            <!-- Honeypot anti-bot: disembunyikan, manusia tidak mengisinya -->
            <input
              v-model="form.website"
              type="text"
              name="website"
              tabindex="-1"
              autocomplete="off"
              class="share-hp"
              aria-hidden="true"
            />

            <div v-if="errUmum" class="share-error mt-2">{{ errUmum }}</div>
          </v-card-text>

          <v-card-actions class="share-card-foot">
            <v-btn text class="text-capitalize" :disabled="kirim" @click="tutupForm"
              >Batal</v-btn
            >
            <v-spacer />
            <v-btn
              depressed
              class="btn-bagikan white--text text-capitalize font-weight-bold rounded-lg"
              :loading="kirim"
              :disabled="kirim"
              @click="submit"
            >
              <v-icon left small>mdi-send-outline</v-icon>
              Kirim Momen
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { getMomen } from "@/api/androidInitApi";
import { kirimMomen } from "@/api/momenPublikApi";

const MAKS_FOTO = 5;
const MAKS_UKURAN_MB = 8;
const FORMAT_OK = ["image/jpeg", "image/png", "image/webp"];
const BULAN_TAMPIL = 6;

const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export default {
  name: "MomenTerbaik",

  data: () => ({
    listMomen: [],
    dialog: false,
    selectedImg: "",
    activeMomen: {},

    // --- form bagikan momen ---
    MAKS_FOTO,
    MAKS_UKURAN_MB,
    showFab: false,
    formDialog: false,
    selesai: false,
    kirim: false,
    dragging: false,
    fotoList: [], // [{ file, url }]
    form: { judul: "", deskripsi: "", tanggal: "", nama: "", kontak: "", website: "" },
    errFoto: "",
    errJudul: "",
    errTanggal: "",
    errUmum: "",

    particles: [],
    ctx: null,
    animationId: null,
  }),

  async mounted() {
    this.initParticles();

    window.addEventListener("resize", this.resizeCanvas);
    window.addEventListener("scroll", this.onScroll, { passive: true });

    this.fetchData();
  },

  beforeDestroy() {
    cancelAnimationFrame(this.animationId);

    window.removeEventListener("resize", this.resizeCanvas);
    window.removeEventListener("scroll", this.onScroll);
    this.bersihkanPreview();
  },

  computed: {
    hariIni() {
      return ymd(new Date());
    },
    batasBawah() {
      const d = new Date();
      d.setMonth(d.getMonth() - BULAN_TAMPIL);
      return ymd(d);
    },
  },

  methods: {
    // ---------- bagikan momen ----------
    onScroll() {
      this.showFab = window.scrollY > 420;
    },

    bukaForm() {
      this.selesai = false;
      this.errFoto = this.errJudul = this.errTanggal = this.errUmum = "";
      if (!this.form.tanggal) this.form.tanggal = this.hariIni;
      this.formDialog = true;
    },

    tutupForm() {
      if (this.kirim) return;
      this.formDialog = false;
      if (this.selesai) this.resetForm();
    },

    resetForm() {
      this.bersihkanPreview();
      this.fotoList = [];
      this.form = {
        judul: "",
        deskripsi: "",
        tanggal: "",
        nama: "",
        kontak: "",
        website: "",
      };
      this.selesai = false;
    },

    bersihkanPreview() {
      this.fotoList.forEach((f) => URL.revokeObjectURL(f.url));
    },

    pilihFoto(e) {
      this.tambahFile(Array.from(e.target.files || []));
      e.target.value = ""; // supaya foto yang sama bisa dipilih lagi
    },

    onDrop(e) {
      this.dragging = false;
      this.tambahFile(Array.from((e.dataTransfer && e.dataTransfer.files) || []));
    },

    tambahFile(files) {
      this.errFoto = "";
      const pesan = [];
      for (const file of files) {
        if (this.fotoList.length >= MAKS_FOTO) {
          pesan.push(`Maksimal ${MAKS_FOTO} foto`);
          break;
        }
        if (!FORMAT_OK.includes(file.type)) {
          pesan.push(`"${file.name}" bukan JPG/PNG/WEBP`);
          continue;
        }
        if (file.size > MAKS_UKURAN_MB * 1024 * 1024) {
          pesan.push(`"${file.name}" lebih dari ${MAKS_UKURAN_MB} MB`);
          continue;
        }
        this.fotoList.push({ file, url: URL.createObjectURL(file) });
      }
      if (pesan.length) this.errFoto = pesan.join(". ");
    },

    hapusFoto(i) {
      const [f] = this.fotoList.splice(i, 1);
      if (f) URL.revokeObjectURL(f.url);
      this.errFoto = "";
    },

    // 08xxx -> 628xxx (sama seperti form tenant)
    rapikanKontak() {
      let k = String(this.form.kontak || "").replace(/\D/g, "");
      if (k.startsWith("0")) k = "62" + k.slice(1);
      this.form.kontak = k;
    },

    async submit() {
      this.errFoto = this.errJudul = this.errTanggal = this.errUmum = "";

      const judul = this.form.judul.trim();
      let valid = true;
      if (this.fotoList.length === 0) {
        this.errFoto = "Pilih minimal 1 foto";
        valid = false;
      }
      if (judul.length < 3) {
        this.errJudul = "Judul minimal 3 karakter";
        valid = false;
      }
      if (
        !this.form.tanggal ||
        this.form.tanggal > this.hariIni ||
        this.form.tanggal < this.batasBawah
      ) {
        this.errTanggal = `Tanggal harus dalam ${BULAN_TAMPIL} bulan terakhir (maksimal hari ini)`;
        valid = false;
      }
      if (!valid) return;

      const fd = new FormData();
      fd.append("judul_momen", judul);
      fd.append("deskripsi", this.form.deskripsi.trim());
      fd.append("tanggal_ambil", this.form.tanggal);
      fd.append("nama_pengirim", this.form.nama.trim());
      fd.append("kontak_pengirim", this.form.kontak);
      fd.append("website", this.form.website); // honeypot
      this.fotoList.forEach((f) => fd.append("foto", f.file));

      this.kirim = true;
      try {
        await kirimMomen(fd);
        this.selesai = true;
      } catch (e) {
        const r = e && e.response && e.response.data;
        console.error("kirimMomen gagal:", e && e.response && e.response.status, r);
        const dariServer =
          r &&
          (r.message ||
            (r.response && (r.response.message || r.response.data)) ||
            (typeof r === "string" ? r : ""));
        this.errUmum =
          (typeof dariServer === "string" && dariServer) ||
          (e && e.response
            ? `Gagal mengirim momen (kode ${e.response.status}).`
            : "Gagal mengirim momen. Periksa koneksi lalu coba lagi.");
      } finally {
        this.kirim = false;
      }
    },

    // ---------- galeri ----------

    async fetchData() {
      try {
        // Server sudah memfilter is_active = 1 & 6 bulan terakhir;
        // di sini hanya jaga-jaga momen tanpa foto.
        this.listMomen = ((await getMomen()) || []).filter((m) => m.list_foto);
      } catch (e) {
        console.error(e);
      }
    },

    splitPhotos(string) {
      return string ? string.split(",") : [];
    },

    formatDate(dateStr) {
      const options = { year: "numeric", month: "long", day: "numeric" };

      return new Date(dateStr).toLocaleDateString("id-ID", options);
    },

    openDetail(img, momen) {
      this.selectedImg = "https://berkah.bondowosokab.go.id:5500/uploads/" + img;

      this.activeMomen = momen;

      this.dialog = true;
    },

    initParticles() {
      const canvas = this.$refs.particleCanvas;

      if (!canvas) {
        return;
      }

      this.ctx = canvas.getContext("2d");

      this.resizeCanvas();

      const particleCount = window.innerWidth <= 768 ? 20 : 40;

      this.particles = Array.from(
        {
          length: particleCount,
        },
        () => ({
          x: Math.random() * canvas.width,

          y: Math.random() * canvas.height,

          vx: (Math.random() - 0.5) * 0.2,

          vy: (Math.random() - 0.5) * 0.2,

          radius: Math.random() * 1.2 + 0.6,
        })
      );

      this.animate();
    },

    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;

      if (!canvas) {
        return;
      }

      canvas.width = window.innerWidth;

      canvas.height = window.innerHeight;
    },

    animate() {
      if (!this.ctx) {
        return;
      }

      const canvas = this.$refs.particleCanvas;

      if (!canvas) {
        return;
      }

      this.ctx.clearRect(0, 0, canvas.width, canvas.height);

      this.particles.forEach((particle) => {
        particle.x += particle.vx;

        particle.y += particle.vy;

        if (particle.x < 0 || particle.x > canvas.width) {
          particle.vx *= -1;
        }

        if (particle.y < 0 || particle.y > canvas.height) {
          particle.vy *= -1;
        }

        this.ctx.beginPath();

        this.ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);

        this.ctx.fillStyle = "rgba(1, 140, 116, 0.18)";

        this.ctx.fill();
      });

      this.animationId = requestAnimationFrame(this.animate);
    },
  },
};
</script>

<style scoped>
.momen-app {
  --teal: #018c74;
  --teal-dark: #006b5b;
  --teal-soft: #e8f5f2;

  --gold: #f3a928;
  --gold-soft: #fff5df;

  --text: #1d2935;
  --text-soft: #6e7b87;

  --background: #f5f8fa;
  --white: #ffffff;

  --border: rgba(20, 75, 70, 0.1);

  background: #f6f9f9 !important;
}

.v-application--wrap {
  background: transparent !important;
}

.main-container {
  position: relative;
  z-index: 5;

  padding: 36px 24px 60px !important;
}

.content-wrapper {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;
}

.page-intro {
  display: flex;

  align-items: flex-end;

  justify-content: space-between;

  gap: 30px;

  margin-bottom: 36px;
}

.intro-label {
  display: flex;
  align-items: center;

  gap: 9px;

  color: var(--teal);

  font-size: 0.68rem;

  font-weight: 900;

  letter-spacing: 1.7px;
}

.intro-line {
  width: 24px;
  height: 3px;

  border-radius: 10px;

  background: var(--gold);
}

.intro-title {
  margin: 8px 0 6px;

  color: var(--text);

  font-size: clamp(2rem, 4vw, 3rem);

  line-height: 1.05;

  font-weight: 900;

  letter-spacing: -1.5px;
}

.intro-title span {
  color: var(--teal);
}

.intro-description {
  margin: 0;

  max-width: 620px;

  color: var(--text-soft);

  font-size: 0.9rem;

  line-height: 1.6;
}

.momen-counter {
  min-width: 190px;

  display: flex;
  align-items: center;

  gap: 13px;

  padding: 15px 18px;

  border-radius: 16px;

  background: rgba(255, 255, 255, 0.9);

  border: 1px solid var(--border);

  box-shadow: 0 10px 30px rgba(40, 80, 75, 0.06);
}

.counter-icon {
  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  color: var(--teal);

  background: var(--teal-soft);
}

.counter-value {
  color: var(--text);

  font-size: 1.35rem;

  line-height: 1;

  font-weight: 900;
}

.counter-label {
  margin-top: 4px;

  color: var(--text-soft);

  font-size: 0.62rem;

  font-weight: 800;

  letter-spacing: 1px;
}

.momen-section {
  background: rgba(255, 255, 255, 0.94);

  border: 1px solid var(--border);

  border-radius: 24px;

  box-shadow: 0 18px 60px rgba(30, 70, 65, 0.07);

  padding: 25px;

  margin-bottom: 22px;
}

.momen-header {
  display: flex;

  align-items: flex-end;

  gap: 16px;

  margin-bottom: 18px;
}

.momen-header-line {
  flex-shrink: 0;

  width: 5px;
  height: 40px;

  border-radius: 3px;

  background: linear-gradient(180deg, var(--teal), var(--gold));

  margin-bottom: 2px;
}

.momen-header-text {
  flex: 1 1 auto;

  min-width: 0;
}

.momen-header-label {
  color: var(--gold);

  font-size: 0.62rem;

  font-weight: 900;

  letter-spacing: 1.4px;
}

.momen-header-title {
  margin-top: 3px;

  color: var(--text);

  font-size: 1.35rem;

  font-weight: 900;

  line-height: 1.2;
}

.momen-header-id {
  flex-shrink: 0;

  color: var(--text-soft);

  font-size: 0.95rem;

  font-weight: 900;

  opacity: 0.35;
}

.momen-grid {
  display: grid;

  grid-template-columns: 1.1fr 1fr;

  gap: 12px;
}

.momen-card {
  border-radius: 18px;

  overflow: hidden;

  border: 1px solid var(--border);

  cursor: pointer;

  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.momen-card:hover {
  transform: translateY(-4px);

  border-color: rgba(1, 140, 116, 0.3);

  box-shadow: 0 16px 36px rgba(30, 80, 75, 0.14);
}

.momen-img {
  transition: transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.momen-card:hover .momen-img {
  transform: scale(1.06);
}

.momen-main-wrapper {
  min-width: 0;
}

.momen-main {
  border-width: 2px;
}

.momen-overlay {
  position: absolute;
  inset: 0;

  background: linear-gradient(to top, rgba(1, 60, 50, 0.75) 0%, transparent 60%);
}

.momen-overlay-title {
  color: white;

  font-size: 0.82rem;

  font-weight: 800;
}

.momen-overlay-sub {
  color: rgba(255, 255, 255, 0.8);

  font-size: 0.62rem;

  margin-top: 2px;
}

.momen-sub-wrapper {
  display: grid;

  grid-template-columns: repeat(2, 1fr);

  gap: 10px;

  align-content: start;
}

.momen-sub-overlay {
  position: absolute;
  inset: 0;

  background: rgba(1, 140, 116, 0.28);

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 0;

  transition: opacity 0.25s ease;
}

.momen-sub:hover .momen-sub-overlay {
  opacity: 1;
}

.momen-placeholder {
  grid-column: 1 / -1;

  height: 170px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--text-soft);

  font-size: 0.7rem;

  font-style: italic;

  background: #f7f9f9;

  border: 1px dashed var(--border);

  border-radius: 18px;
}

.empty-detail {
  padding: 80px 25px;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-direction: column;

  text-align: center;

  background: rgba(255, 255, 255, 0.9);

  border: 1px dashed rgba(1, 140, 116, 0.2);

  border-radius: 24px;
}

.empty-detail-icon {
  width: 90px;
  height: 90px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 25px;

  color: var(--teal);

  background: var(--teal-soft);

  margin-bottom: 18px;
}

.empty-detail-title {
  color: var(--text);

  font-size: 1.15rem;

  font-weight: 900;
}

.empty-detail-description {
  max-width: 400px;

  margin-top: 7px;

  color: var(--text-soft);

  font-size: 0.75rem;

  line-height: 1.5;
}

.page-footer {
  display: flex;

  align-items: center;

  justify-content: center;

  gap: 10px;

  margin-top: 30px;

  color: #94a0a7;

  font-size: 0.57rem;

  font-weight: 800;

  letter-spacing: 1px;
}

.page-footer span {
  width: 4px;
  height: 4px;

  border-radius: 50%;

  background: var(--gold);
}

.detail-dialog-panel {
  background: white !important;

  border-radius: 26px !important;

  border: 1px solid rgba(1, 140, 116, 0.15) !important;

  box-shadow: 0 24px 70px rgba(20, 50, 45, 0.25) !important;
}

.dialog-image-col {
  background: #0d1f1c;

  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-info-col {
  border-left: 1px solid rgba(1, 140, 116, 0.1);
}

.detail-badge {
  display: inline-flex;

  align-items: center;

  gap: 6px;

  padding: 6px 9px;

  border-radius: 7px;

  color: #018c74;

  background: #e8f5f2;

  font-size: 0.61rem;

  font-weight: 900;

  letter-spacing: 1px;

  width: fit-content;
}

.dialog-title {
  color: #1d2935;

  font-size: 1.5rem;

  font-weight: 900;

  line-height: 1.2;
}

.dialog-meta-box {
  padding: 18px;

  border-radius: 16px;

  background: #f6fbfa;

  border: 1px solid rgba(1, 140, 116, 0.12);
}

.dialog-meta-row {
  display: flex;

  align-items: center;

  gap: 10px;

  margin-bottom: 12px;
}

.dialog-meta-row .date-icon {
  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;

  color: #f3a928;

  background: #fff5df;
}

.dialog-meta-date {
  color: #1d2935;

  font-size: 0.75rem;

  font-weight: 800;
}

.dialog-meta-desc {
  margin: 0;

  color: #6e7b87;

  font-size: 0.8rem;

  line-height: 1.7;

  letter-spacing: 0.2px;
}

.dialog-close-btn {
  background: #018c74 !important;

  color: white !important;

  font-weight: 800 !important;

  border-radius: 14px !important;

  padding: 22px 0 !important;
}

@media (max-width: 960px) {
  .main-container {
    padding: 30px 18px 50px !important;
  }

  .page-intro {
    align-items: flex-start;
  }

  .momen-section {
    padding: 20px;
  }

  .momen-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .main-container {
    padding: 22px 10px 40px !important;
  }

  .page-intro {
    display: block;

    margin-bottom: 20px;
  }

  .intro-label {
    font-size: 0.56rem;

    letter-spacing: 1.2px;
  }

  .intro-title {
    margin-top: 7px;

    font-size: 1.9rem;

    letter-spacing: -1px;
  }

  .intro-description {
    font-size: 0.72rem;

    max-width: 100%;

    line-height: 1.5;
  }

  .momen-counter {
    margin-top: 14px;

    min-width: 0;

    width: 100%;

    padding: 11px 13px;
  }

  .counter-icon {
    width: 36px;
    height: 36px;
  }

  .counter-value {
    font-size: 1.1rem;
  }

  .counter-label {
    font-size: 0.55rem;
  }

  .momen-section {
    padding: 14px;

    border-radius: 19px;

    margin-bottom: 16px;
  }

  .momen-header {
    gap: 10px;

    margin-bottom: 13px;
  }

  .momen-header-line {
    width: 4px;
    height: 32px;
  }

  .momen-header-label {
    font-size: 0.55rem;
  }

  .momen-header-title {
    font-size: 1rem;
  }

  .momen-grid {
    grid-template-columns: 1fr;
  }

  .momen-sub-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }

  .dialog-info-col {
    border-left: none;

    border-top: 1px solid rgba(1, 140, 116, 0.1);
  }

  .dialog-title {
    font-size: 1.2rem;
  }

  .page-footer {
    margin-top: 22px;

    font-size: 0.48rem;

    gap: 7px;
  }
}

@media (max-width: 420px) {
  .intro-title {
    font-size: 1.7rem;
  }

  .momen-section {
    padding: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .momen-card {
    transition: none !important;
  }
}

.momen-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}

/* =====================================================
   BAGIKAN MOMEN (hero, tombol beranimasi, form)
   ===================================================== */
.share-hero {
  animation: share-rise 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}
.share-hero-text {
  max-width: 640px;
}

.share-cta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 18px;
  margin-top: 20px;
}
.share-note {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: var(--text-soft);
}
.share-list-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 18px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--text-soft);
}

/* Tombol utama: gradient bergerak + pulse ring + kilau (sama gaya "Kontribusi Publik") */
.btn-bagikan {
  position: relative;
  overflow: hidden;
  letter-spacing: 0.2px;
  background: linear-gradient(
    120deg,
    #018c74,
    #02a98c,
    #018c74,
    #cfa22d,
    #018c74
  ) !important;
  background-size: 300% 300% !important;
  animation: share-gradient 8s ease infinite, share-pulse 2.4s ease-out infinite;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease;
  will-change: transform, box-shadow;
}
.btn-bagikan::after {
  content: "";
  position: absolute;
  top: 0;
  left: -75%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.45) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: skewX(-20deg);
  animation: share-shimmer 3.2s ease-in-out infinite;
  pointer-events: none;
}
.btn-bagikan ::v-deep .v-btn__content {
  position: relative;
  z-index: 1;
}
.btn-bagikan:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 10px 24px rgba(1, 140, 116, 0.35) !important;
  animation-play-state: running, paused;
}
.btn-bagikan:hover::after {
  animation-duration: 1.1s;
}
.btn-bagikan:active {
  transform: translateY(0) scale(0.97);
}
.bagikan-icon {
  animation: share-breathe 2.4s ease-in-out infinite;
}
.btn-bagikan:hover .bagikan-icon {
  animation: none;
  transform: rotate(-12deg) scale(1.2);
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* Tombol melayang */
.share-fab {
  position: fixed !important;
  right: 20px;
  bottom: 22px;
  z-index: 20;
  background: linear-gradient(135deg, #018c74, #02a98c) !important;
  box-shadow: 0 8px 22px rgba(1, 140, 116, 0.4) !important;
  animation: share-pulse 2.4s ease-out infinite, share-bob 3s ease-in-out infinite;
}
.share-fab-enter-active,
.share-fab-leave-active {
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.25s ease;
}
.share-fab-enter,
.share-fab-leave-to {
  transform: translateY(40px) scale(0.4);
  opacity: 0;
}

/* Dialog form */
.share-card {
  border-radius: 20px !important;
  overflow: hidden;
}
.share-card-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(135deg, var(--teal-soft), #fff);
}
.share-card-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #018c74, #02a98c);
}
.share-card-title {
  font-size: 17px;
  font-weight: 900;
  color: var(--text);
}
.share-card-sub {
  font-size: 12px;
  color: var(--text-soft);
}
.share-card-body {
  padding: 20px !important;
}
.share-card-foot {
  padding: 12px 20px 16px !important;
  border-top: 1px solid var(--border);
}

.share-drop {
  border: 2px dashed rgba(1, 140, 116, 0.4);
  border-radius: 16px;
  padding: 22px 16px;
  text-align: center;
  cursor: pointer;
  background: var(--teal-soft);
  transition: background 0.2s, border-color 0.2s, transform 0.2s;
}
.share-drop:hover,
.share-drop--active {
  background: #d9efe9;
  border-color: #018c74;
  transform: scale(1.01);
}
.share-drop--error {
  border-color: #ff5252;
}
.share-drop-icon {
  animation: share-bob 2.6s ease-in-out infinite;
}
.share-drop-title {
  margin-top: 6px;
  font-weight: 800;
  color: var(--text);
}
.share-drop-sub {
  margin-top: 2px;
  font-size: 12px;
  color: var(--text-soft);
}
.share-error {
  margin-top: 6px;
  font-size: 12.5px;
  color: #d32f2f;
}

.share-thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}
.share-thumb {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border);
}
.share-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.share-thumb-badge {
  position: absolute;
  left: 6px;
  bottom: 6px;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.6px;
  color: #fff;
  background: rgba(1, 140, 116, 0.9);
}
.share-thumb-del {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.6);
}
.share-thumb-enter-active,
.share-thumb-leave-active {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.25s;
}
.share-thumb-enter,
.share-thumb-leave-to {
  transform: scale(0.5);
  opacity: 0;
}

.share-hp {
  position: absolute !important;
  left: -9999px;
  width: 1px;
  height: 1px;
  opacity: 0;
}

/* Sukses */
.share-success {
  padding: 40px 28px 34px;
  text-align: center;
}
.share-check {
  width: 84px;
  height: 84px;
  margin-bottom: 10px;
}
.share-check-circle {
  stroke: #018c74;
  stroke-width: 3;
  stroke-dasharray: 151;
  stroke-dashoffset: 151;
  animation: share-draw 0.7s ease forwards;
}
.share-check-mark {
  stroke: #018c74;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 40;
  stroke-dashoffset: 40;
  animation: share-draw 0.45s 0.6s ease forwards;
}
.share-success-title {
  font-size: 22px;
  font-weight: 900;
  color: var(--text);
}
.share-success-text {
  max-width: 420px;
  margin: 8px auto 20px;
  color: var(--text-soft);
  line-height: 1.6;
}

@keyframes share-rise {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes share-gradient {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}
@keyframes share-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(1, 140, 116, 0.55);
  }
  70% {
    box-shadow: 0 0 0 14px rgba(1, 140, 116, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(1, 140, 116, 0);
  }
}
@keyframes share-shimmer {
  0% {
    left: -75%;
  }
  60%,
  100% {
    left: 130%;
  }
}
@keyframes share-breathe {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.18);
  }
}
@keyframes share-bob {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}
@keyframes share-draw {
  to {
    stroke-dashoffset: 0;
  }
}

@media (max-width: 600px) {
  .share-cta-row .btn-bagikan {
    width: 100%;
  }
  .share-fab {
    right: 14px;
    bottom: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .share-hero,
  .btn-bagikan,
  .btn-bagikan::after,
  .bagikan-icon,
  .share-fab,
  .share-drop-icon,
  .share-check-circle,
  .share-check-mark {
    animation: none !important;
  }
  .share-check-circle,
  .share-check-mark {
    stroke-dashoffset: 0;
  }
}
</style>
